import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { translate } from '../../../../../../../utils/translation/translation';
import MenuItem from '../../MenuItem/MenuItem';
import { useRecoilValue } from 'recoil';
import { translationsState } from '../../../../../../../atoms/translation/translation.atom';
import { colors } from '../../../../../../../styles/colors';
import { InputValueType } from '../../../../../../../hooks/useForm/useForm';

export type RemoveActionProps = {
  id?: string;
  onClick?: (value: InputValueType) => void;
};

export const RemoveAction = ({ id, onClick }: RemoveActionProps) => {
  const translations = useRecoilValue(translationsState);

  return (
    <>
      <MenuItem
        onClick={() => onClick?.(id)}
        style={{ color: colors.inputErrorColor }}
      >
        <DeleteIcon width={20} height={20} />
        {translate(translations, 'REMOVE_ACTION.REMOVE')}
      </MenuItem>
    </>
  );
};

export default RemoveAction;
